// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"4740d594","787":"a57fbba3"}[chunkId] + ".chunk.js";
};